<template>
  <v-card
    class="pt-3 px-4 ma-0 oder-box-products"
    :style="{
              background: product && product.isTransfered ? 'rgba(204, 204, 204, 1)' : '#fffbf8',
              border: '1px solid #cccccccc',
              overflow: 'auto',
            }"
    outlined
    tile
  >
    <div class="align-center d-flex justify-space-between">
      <div
        style="color: #ac0606; font-weight: 600; font-size: 14px"
        class="d-flex pl-3"
      >
        <span style="width: 150px">Sản phẩm gia sư</span>
        <div cols="12" class="d-flex pl-6">
          <v-checkbox
            label="Mua mới"
            hide-details
            class="table-layout-checkbox ma-0 pa-0"
            v-model="product.isNew"
            :disabled="isDetailOrder || $route.query.isDuo"
            @change="clickNew(product)"
          />
          <v-checkbox
            label="Gia hạn"
            hide-details
            class="table-layout-checkbox ma-0 pa-0 ml-6"
            v-model="product.isExtend"
            :disabled="isDetailOrder  || $route.query.isDuo"
            @change="clickExtend(product)"
          />
        </div>
      </div>
      <div class="d-flex" v-if="!isDetailOrder && !$route.query.record_type">
        <div
          class="pr-3 cursor-pointer"
          @click="resetProduct(product, indexProd)"
        >
          <svg
            width="14"
            height="19"
            viewBox="0 0 14 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.9987 4.42839V6.92839L10.332 3.59505L6.9987 0.261719V2.76172C5.23059 2.76172 3.5349 3.4641 2.28465 4.71434C1.03441 5.96458 0.332031 7.66028 0.332031 9.42839C0.332031 10.7367 0.715364 11.9534 1.36536 12.9784L2.58203 11.7617C2.20703 11.0701 1.9987 10.2617 1.9987 9.42839C1.9987 8.1023 2.52548 6.83053 3.46316 5.89285C4.40085 4.95517 5.67262 4.42839 6.9987 4.42839ZM12.632 5.87839L11.4154 7.09505C11.782 7.79505 11.9987 8.59505 11.9987 9.42839C11.9987 10.7545 11.4719 12.0262 10.5342 12.9639C9.59655 13.9016 8.32478 14.4284 6.9987 14.4284V11.9284L3.66536 15.2617L6.9987 18.5951V16.0951C8.76681 16.0951 10.4625 15.3927 11.7127 14.1424C12.963 12.8922 13.6654 11.1965 13.6654 9.42839C13.6654 8.12005 13.282 6.90339 12.632 5.87839Z"
              fill="#3390FF"
            />
          </svg>
        </div>
        <div @click="deleteProduct(product, indexProd)" class="cursor-pointer">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.4987 0.927734V1.76107H0.332031V3.42773H1.16536V14.2611C1.16536 14.7031 1.34096 15.127 1.65352 15.4396C1.96608 15.7521 2.39 15.9277 2.83203 15.9277H11.1654C11.6074 15.9277 12.0313 15.7521 12.3439 15.4396C12.6564 15.127 12.832 14.7031 12.832 14.2611V3.42773H13.6654V1.76107H9.4987V0.927734H4.4987ZM2.83203 3.42773H11.1654V14.2611H2.83203V3.42773ZM4.4987 5.0944V12.5944H6.16536V5.0944H4.4987ZM7.83203 5.0944V12.5944H9.4987V5.0944H7.83203Z"
              fill="#AC0606"
            />
          </svg>
        </div>
      </div>
      <div class="d-flex" style="column-gap: 10px" v-if="isDetailOrder && product.trialExchangeStatus == 'finished' || product && product.isTransfered">
        <div v-if="isDetailOrder && product.trialExchangeStatus == 'finished'" class="tag-complete">
          ĐÃ HOÀN TẤT
        </div>
        <div v-if="product && product.isTransfered" style="color: rgba(245, 108, 34, 1);padding: 4px 12px;font-weight: 500; border-radius: 4px; border: 1px solid  rgba(245, 108, 34, 1);background: #FFF;font-size: 13px">
          ĐÃ CHUYỂN ĐỔI
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="6" class="py-0 pt-2">
        <v-simple-table
          class="table-layout table-order-custom-tutor"
          :style="{  background: product && product.isTransfered ? 'rgba(204, 204, 204, 1)' : '#fffbf8'}">
          <thead>
            <tr>
              <th
                class="col-program text-left"
                style="font-size: 12px !important"
              >
                CHƯƠNG TRÌNH
              </th>
              <th
                class="col-teacher text-left"
                style="font-size: 12px !important"
              >
                GIÁO VIÊN
              </th>
              <th
                class="col-package text-left"
                style="font-size: 12px !important"
              >
                GÓI
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :name="`Chương trình ${indexProd + 1}`"
                  :rules="{ required: true }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <div v-on="{ ...tooltip }">
                        <v-autocomplete
                          :items="curriculums"
                          :error-messages="errors"
                          item-value="id"
                          item-text="title"
                          :aLight="'right'"
                          placeholder="Chọn"
                          label=""
                          auto
                          class="product-select-curriculum"
                          v-model="product.curriculumId"
                          :disabled="
                            isDetailOrder ||
                            $route.query.record_type == 'transfer_product'
                          "
                          @change="onChangeCurriculum(product)"
                          :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '250',
                          }"
                        >
                        </v-autocomplete>
                      </div>
                    </template>
                    <span>{{
                      curriculumObj[product.curriculumId] || null
                    }}</span>
                  </v-tooltip>
                </validation-provider>
              </td>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :name="`Giáo viên ${indexProd + 1}`"
                  :rules="{ required: true }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <div v-on="{ ...tooltip }">
                        <v-autocomplete
                          :error-messages="errors"
                          :items="teacherTypes"
                          item-value="id"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Chọn "
                          label=""
                          auto
                          v-model="product.teacherType"
                          :disabled="
                            isDetailOrder ||
                            $route.query.record_type == 'transfer_product'
                          "
                          @change="onChangeTeacherType(product)"
                          :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '250',
                          }"
                        ></v-autocomplete>
                      </div>
                    </template>
                    <span>{{
                      teacherTypeObj[product.teacherType] || null
                    }}</span>
                  </v-tooltip>
                </validation-provider>
              </td>
              <td>
                <div
                  v-if="isDetailOrder"
                  class="string-form mb-2"
                  style="width: 100%"
                >
                  <span v-if="product.package">
                    {{ classTypeObj[product.package.split("-")[0]] }} -
                    {{ product.package.split("-")[1] }} buổi
                  </span>
                </div>
                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :name="`Gói ${indexProd + 1}`"
                  :rules="{ required: true }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <div v-on="{ ...tooltip }">
                        <v-autocomplete
                          :items="product.packageOptions"
                          :error-messages="errors"
                          item-value="uniqueId"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Chọn "
                          label=""
                          auto
                          v-model="product.package"
                          class="product-select-package"
                          :disabled="
                            isDetailOrder ||
                            $route.query.record_type == 'transfer_product'
                          "
                          @change="onChangePackage(product)"
                          :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '250',
                          }"
                        ></v-autocomplete>
                      </div>
                    </template>
                    <span>{{
                      product.packageOptions &&
                      product.packageOptions.length &&
                      product.packageOptions.find(
                        (itemX) => itemX.uniqueId === product.package
                      )
                        ? product.packageOptions.find(
                            (itemX) => itemX.uniqueId === product.package
                          ).name
                        : null
                    }}</span>
                  </v-tooltip>
                </validation-provider>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-simple-table
          class="table-layout table-order-custom-tutor"
          :style="{  background: product && product.isTransfered ? 'rgba(204, 204, 204, 1)' : '#fffbf8'}">
          <thead>
            <tr>
              <th
                class="col-product text-left pb-0"
                style="font-size: 12px !important"
              >
                SẢN PHẨM
              </th>
              <th
                class="col-count text-left pb-0"
                style="font-size: 12px !important"
              >
                SỐ GÓI
              </th>
              <th
                class="col-price text-left pb-0"
                style="font-size: 12px !important"
              >
                ĐƠN GIÁ
              </th>
              <th
                class="col-discount text-left pb-0"
                style="font-size: 12px !important"
              >
                KHUYẾN MẠI
              </th>
              <th
                class="col-total text-left pb-0"
                style="font-size: 12px !important"
              >
                THÀNH TIỀN
              </th>
              <th
                class="col-child text-left pb-0"
                style="font-size: 12px !important"
              >
                CHỌN CON
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :name="`Sản phẩm ${indexProd + 1}`"
                  :rules="{ required: true }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <div v-on="{ ...tooltip }">
                        <v-autocomplete
                          :items="product.products"
                          :error-messages="errors"
                          item-value="id"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Chọn"
                          label=""
                          class="product-select text-normalcase"
                          auto
                          :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '310',
                          }"
                          @change="onSelectProduct(product)"
                          v-model="product.productId"
                          :disabled="
                            isDetailOrder ||
                            $route.query.record_type == 'transfer_product'
                          "
                        >
                          <template slot="selection" slot-scope="data">
                            <span v-if="innerWidth > 1440">{{
                              data.item.name.length > 45
                                ? `${data.item.name.slice(0, 45)}...`
                                : data.item.name
                            }}</span>
                            <span v-else>{{
                              data.item.name.length > 22
                                ? `${data.item.name.slice(0, 22)}...`
                                : data.item.name
                            }}</span>
                          </template>
                          <template slot="item" slot-scope="data">
                            <div>
                              <span
                                style="font-weight: bold; font-size: 14px"
                                >{{ data.item.name }}</span
                              >

                              <div class="text-muted d-flex">
                                <v-icon color="#564F4C">
                                  mdi-circle-small
                                </v-icon>
                                <span
                                  style="font-style: italic; font-size: 10px"
                                  >{{
                                    curriculumObj[data.item.curriculumId]
                                  }}</span
                                >
                              </div>

                              <div class="text-muted d-flex">
                                <v-icon color="#564F4C">
                                  mdi-circle-small
                                </v-icon>
                                <span
                                  style="font-style: italic; font-size: 10px"
                                  >{{ classTypeObj[data.item.classTypeId] }} -
                                  {{ teacherTypeObj[data.item.teacherTypeId] }}
                                  - {{ data.item.numOfLesson }} buổi</span
                                >
                              </div>
                            </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </template>
                    <span>{{
                      product.products &&
                      product.products.find(
                        (itemX) => itemX.id === product.productId
                      )
                        ? product.products.find(
                            (itemX) => itemX.id === product.productId
                          ).name
                        : null
                    }}</span>
                  </v-tooltip>
                </validation-provider>
              </td>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :name="`Số gói ${indexProd + 1}`"
                  :rules="{ required: true, max_value: 100, min_value: 1 }"
                >
                  <v-text-field
                    label=""
                    :error-messages="errors"
                    placeholder="Nhập số gói"
                    dense
                    type="number"
                    v-model="product.count"
                    :disabled="
                      isDetailOrder ||
                      $route.query.record_type == 'transfer_product'
                    "
                    @change="updateDiscount(product)"
                    @keyup="updateDiscount(product)"
                    @mouseup="updateDiscount(product)"
                  ></v-text-field>
                </validation-provider>
              </td>
              <td class="text-left">
                <span
                  v-if="product.priceType && product.priceType === 'unchanged'"
                >
                  {{
                    product.price || product.price === 0
                      ? formatCurrency(product.price)
                      : null
                  }}
                </span>
                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :name="`Đơn giá ${indexProd + 1}`"
                  :rules="{
                    required: true,
                    max_value: product.maxPrice,
                    min_value: product.minPrice,
                  }"
                >
                  <v-text-field
                    label=""
                    :error-messages="errors"
                    :placeholder="`${formatCurrency(
                      product.minPrice
                    )} - ${formatCurrency(product.maxPrice)}`"
                    dense
                    type="number"
                    v-model="product.price"
                    :disabled="
                      isDetailOrder ||
                      $route.query.record_type == 'transfer_product'
                    "
                  ></v-text-field>
                </validation-provider>
              </td>
              <td class="text-left">
                <v-text-field
                  label=""
                  dense
                  type="text"
                  class="custom-color"
                  disabled
                  :value="formatCurrency(product.discount || 0)"
                ></v-text-field>
              </td>
              <td>
                <div
                  v-if="isDetailOrder"
                  class="string-form mb-2"
                  style="width: 100%"
                >
                  {{ formatCurrency(product.intoMoney) }}
                </div>
                <v-text-field
                  v-else
                  label=""
                  placeholder="Nhập thành tiền"
                  dense
                  type="text"
                  class="custom-color"
                  disabled
                  :value="formatCurrency(getPay(product))"
                ></v-text-field>
              </td>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :name="`Con ${indexProd + 1}`"
                  :rules="{ required: true }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <div v-on="{ ...tooltip }">
                        <v-autocomplete
                          :items="sortedChilds"
                          ref="child"
                          :style="{ 'min-width': '150px' }"
                          :error-messages="errors"
                          item-value="id"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Chọn con đã có tài khoản (Nếu có)"
                          label=""
                          v-model="product.customerId"
                          :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '240',
                          }"
                          :disabled="
                            isDetailOrder || $route.query.record_type == 'transfer_product'  && cacheAutoFill.typeTransfer && cacheAutoFill.typeTransfer.id !== 2"
                          :class="'select-customer'"
                        >
                          <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <div
                                    style="font-weight: 500; margin-bottom: 2px"
                                  >
                                    {{ item.name }}
                                  </div>
                                  <div
                                    v-if="item.name"
                                    style="
                                      font-style: italic;
                                      font-size: 12px;
                                      margin-bottom: 2px;
                                    "
                                  >
                                    (<span style="font-weight: 500">
                                      Tài khoản: {{ item.user || "Chưa có" }}
                                    </span>
                                  </div>
                                  <div
                                    v-if="item.name"
                                    style="font-style: italic; font-size: 12px"
                                  >
                                    Đơn tạo gần nhất:
                                    {{ item.order ? item.order : "Chưa có" }} )
                                  </div>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>
                    </template>
                    <span>{{
                      childs &&
                      childs.find((itemX) => itemX.id === product.customerId)
                        ? childs.find(
                            (itemX) => itemX.id === product.customerId
                          ).fullName
                        : null
                    }}</span>
                  </v-tooltip>
                </validation-provider>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <div
      v-if="checkShowData(product)"
      class="d-flex justify-space-between pb-3"
      style="width: 28%"
    >
      <div style="font-size: 14px; color: gray">CHÍNH SÁCH ƯU ĐÃI</div>
      <div>
        {{ getDiscountBonus(product) }}
      </div>
    </div>
    <product-campaign
      :is-detail="isDetailOrder"
      :product="product"
      @select="openCouponModal(product)"
      @showDetailKM="showDetailKM($event)"
    />
  </v-card>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
import ProductCampaign from "../ProductCampaign";
import { getDiscount } from '@/helpers/campaign';
const OrderRepository = RepositoryFactory.get('order');


export default {
  props: {
    cacheAutoFill: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
    curriculums: {
      type: Array,
      default: () => [],
    },
    teacherTypes: {
      type: Array,
      default: () => [],
    },
    curriculumObj: {
      type: Object,
      default: () => ({}),
    },
    teacherTypeObj: {
      type: Object,
      default: () => ({}),
    },
    classTypeObj: {
      type: Object,
      default: () => ({}),
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    childs: {
      type: Array,
      default: () => [],
    },
    sortedChilds: {
      type: Array,
      default: () => [],
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ProductCampaign,
  },
  methods: {
    checkShowData(product) {
      if (!product.products) return false;
      const findProduct = product.products.find(
        (item) => item.id === product.productId
      );
      if (findProduct) {
        if (findProduct.pricePolicies && findProduct.pricePolicies.length) {
          if (
            findProduct.pricePolicies[0].additionalDuration ||
            findProduct.pricePolicies[0].additionalNumOfLesson
          ) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
    getDiscountBonus(product) {
      console.log("product", product);
      const findProduct = product.products.find(
        (item) => item.id === product.productId
      );
      if (findProduct) {
        if (findProduct.pricePolicies && findProduct.pricePolicies.length) {
          return `Tặng thêm ${
            findProduct.pricePolicies[0].additionalDuration ||
            findProduct.pricePolicies[0].additionalNumOfLesson
          } ${product.type === "duo" ? "tháng học" : "buổi học"}`;
        }
        return "";
      }
    },
    getPay(item) {
      let d = item.discount || 0;
      let p = (item.count || 0) * (item.price || 0);
      return Math.max(0, p - d);
    },
    updateDiscount(product) {
      product.discount = getDiscount(product);
    },
    onSelectProduct(product){
      const productSelected = product.products.find((item) => item.id === product.productId);
      product.productID = productSelected.productId;
      product.curriculumId = productSelected.curriculumId;
      product.teacherType = productSelected.teacherTypeId;
      product.productName = productSelected.name;
      product.subjectId = productSelected.subjectId;
      product.package = `${productSelected.classTypeId}-${productSelected.numOfLesson}`;
      product.classTypeId = productSelected.classTypeId;
      product.productCode = productSelected.code;
      product.campaigns = [];
      product.endDate = productSelected.endDate;
      this.getClassType(product);
      if (productSelected.pricePolicies.length) {
        product.priceType = productSelected.pricePolicies[0].priceType;
        product.price = null;
        if (productSelected.pricePolicies[0].priceType == 'unchanged') {
          product.price = productSelected.pricePolicies[0].minPrice;
        }
        product.maxPrice = productSelected.pricePolicies[0].maxPrice;
        product.minPrice = productSelected.pricePolicies[0].minPrice;
      }
      product.discount = getDiscount(product);
    },
    async searchSku(product_type = 'tutor', product) {
      const pac = product.packageOptions.find(item => item.uniqueId === product.package);
        const params = {
          product_type,
          include_price_policy: 1,
          class_type_ids: pac ? pac.idReal : null,
          teacher_type_ids: product.teacherType,
          curriculum_id: product.curriculumId,
          transaction_status: 'selling',
          status: 'active',
          num_of_lesson: pac ? pac.id : null,
        };
        const res = await OrderRepository.advanceSearchForCombo(params);
        product.products = res.data;
    },
    onChangePackage(product) {
      product.productId = null;
      product.productName = null;
      product.price = null;
      product.products = [];
      product.campaigns = [];
      this.searchSku('tutor', product);
    },
    onChangeTeacherType(product) {
      this.getClassType(product);
      product.productId = null;
      product.productName = null;
      product.package = null;
      product.price = null;
      product.products = [];
      product.campaigns = [];
      this.searchSku('tutor', product);
    },
    async onChangeCurriculum(product) {
      this.getClassType(product);
      product.productId = null;
      product.productName = null;
      product.package = null;
      product.price = null;
      product.products = [];
      product.campaigns = [];
      await this.searchSku('tutor', product);
    },
    async getClassType(prod) {
      if (prod.curriculumId && prod.teacherType) {
        const params = {
          curriculum_id: prod.curriculumId,
          teacher_type_id: prod.teacherType,
        }
        const res = await OrderRepository.getClassType(params);
        prod.packageOptions = res.data.map((item) => {
          return {
            uniqueId: `${item.classTypeId}-${item.numOfLesson}`,
            id: item.numOfLesson,
            idReal: item.classTypeId,
            name: `${this.classTypeObj[item.classTypeId]} - ${item.numOfLesson} buổi`,
          };
        });
      }
    },
    resetProduct(product) {
      if ( product.type == 'tutor' ) {
        product.curriculumId = null;
        product.teacherType = null;
        product.package = null;
        product.productId = null;
        product.count = 1;
        product.price = null;
        product.discount = 0;
        product.intoMoney = null;
        product.customerId = null;
        product.isNew = false;
        product.isExtend = false;
        product.packageOptions = [];
        product.products = this.skuTutors;
        product.maxPrice = null;
        product.minPrice = null;
        product.priceType = 'unchanged';
        product.productName = null;
        product.campaigns = [];
      }
    },
    clickNew(product) {
      product.isExtend = false
      product.campaigns = [];
      product.discount = getDiscount(product);
    },
    clickExtend(product) {
      product.isNew = false;
      product.campaigns = [];
      product.discount = getDiscount(product);
    },
    // function $emit for parent component
    deleteProduct(product, index) {
      this.$emit("deleteProduct", { product, index });
    },
    openCouponModal(item) {
      if (this.isDetailOrder) return;
      if (this.isDetailOrder) return;
      if (!item.isNew && !item.isExtend) {
        return this.$swal({
          type: "error",
          title: "Thông báo",
          text: "Chưa chọn Mua mới | Gia hạn",
        });
      }
      if (!item.productId) {
        return this.$swal({
          type: "error",
          title: "Thông báo",
          text: "Chưa chọn sản phẩm",
        });
      }
      this.$emit("openCouponModal", item);
    },
    showDetailKM(item) {      
      this.$emit("showDetailKM", item);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}

.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom {
  .col-program {
    width: 12%;
  }
  .col-package {
    width: 12%;
  }
  .col-product {
    width: 12%;
  }
  .col-price {
    width: 12%;
  }
  .col-discount {
    width: 12%;
  }
  .col-total {
    width: 12%;
  }
  .col-child {
    width: 12%;
  }
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}

.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>